import React from "react"

const Button = React.forwardRef(({ 
  className = "", 
  variant = "default", 
  size = "default", 
  children, 
  ...props 
}, ref) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "default":
        return "bg-[#55C5D0] text-white hover:bg-[#3bb3be]"
      case "destructive":
        return "bg-red-600 text-white hover:bg-red-700"
      case "outline":
        return "border border-gray-300 bg-white hover:bg-gray-50 hover:text-gray-900"
      case "secondary":
        return "bg-gray-100 text-gray-900 hover:bg-gray-200"
      case "ghost":
        return "hover:bg-gray-100 hover:text-gray-900"
      case "link":
        return "text-[#55C5D0] underline-offset-4 hover:underline"
      default:
        return "bg-[#55C5D0] text-white hover:bg-[#3bb3be]"
    }
  }

  const getSizeClasses = () => {
    switch (size) {
      case "default":
        return "h-10 px-4 py-2"
      case "sm":
        return "h-9 rounded-md px-3"
      case "lg":
        return "h-11 rounded-md px-8"
      case "icon":
        return "h-10 w-10"
      default:
        return "h-10 px-4 py-2"
    }
  }

  return (
    <button
      ref={ref}
      className={`
        inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md 
        text-sm font-medium ring-offset-white transition-colors 
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#55C5D0] 
        focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 
        [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0
        ${getVariantClasses()}
        ${getSizeClasses()}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  )
})

Button.displayName = "Button"

export { Button } 